// Load config according to environment
//export default require('./appconfig/' + process.env.NODE_ENV);

export default require('./appconfig/production.js');